import React from 'react';
import { useTranslation } from 'react-i18next';
import { genericFormatAmount } from '@panel/commons/helpers/formatAmount';
import {
  InfoWrapper,
  OperationInfo,
  Amount,
  TitleContainer,
  AddressContainer,
  StatusTag,
  PerformanceStatus,
  TagZonaDemand
} from './styles';

function Info({
  address = '',
  pricesOperationTypes = [],
  status = 'DRAFT',
  title = '',
  propertyType = '',
  performanceStatus,
  openDetailPosting,
  isDraft,
  publicationType,
  isExclusiveZone
}) {
  const { t } = useTranslation();
  const [priceAndOperation] = pricesOperationTypes;

  const getAmountValue = indice => {
    if (priceAndOperation) {
      const price = priceAndOperation.amountAndCurrency[indice];
      if (price && price.amount > 0) {
        const { amount, currency } = price;
        return `${genericFormatAmount(amount, currency)}`;
      }
    }
    if (publicationType === 'Emprendimiento') return '';
    return indice === 0 ? t('postings.card.price.withoutPrice') : '';
  };

  return (
    <InfoWrapper>
      <div onClick={openDetailPosting} aria-hidden='true'>
        <OperationInfo>
          <div className='operationContainer' data-panel='posting-realEstateType'>
            {propertyType}
          </div>
          <StatusTag type={status} data-panel='posting-stateLabel'>
            <div />
            {t(`panel.filters.status.${status}`)}
          </StatusTag>
        </OperationInfo>
        <TitleContainer data-panel='posting-title'>
          {title === 'GENERIC_TITLE' ? t('postings.card.info.withoutTitle') : title}
        </TitleContainer>
        <AddressContainer data-panel='posting-address'>
          {isExclusiveZone && <TagZonaDemand>{t('panel.posting.tagZonaDemand')}</TagZonaDemand>}
          {address}
        </AddressContainer>
        <Amount>
          {priceAndOperation && (
            <div className='priceContainer'>
              <span
                data-panel={`posting-priceInfo-${t(`postings.card.operationType.${priceAndOperation.operationType}`)}`}
              >
                {t(`postings.card.operationType.${priceAndOperation.operationType}`)}
              </span>
              <div data-panel='posting-priceInfo-Amount-price'>
                {getAmountValue(0)} {getAmountValue(1) && ` / ${getAmountValue(1)}`}
              </div>
            </div>
          )}
        </Amount>
        {!isDraft &&
          !['OFFLINE', 'WITHOUT_CREDIT'].includes(status) &&
          (performanceStatus && (
            <PerformanceStatus href={null} rel='noopener noreferrer' status={performanceStatus}>
              <span />
              <div data-panel='avisos-performanceStatus-mobile'>
                {t(`panel.aviso.desempeno.status.${performanceStatus}`)}
              </div>
            </PerformanceStatus>
          ))}
      </div>
    </InfoWrapper>
  );
}

export default Info;
